import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import InputField from 'yoda-checkout-components/lib/components/CustomTags/InputField/InputField';
import Constants from '../../utility/Constants';
import giftCardUtility from '../../utility/giftCardUtility';

export class Pin extends Component {
    static defaultProps = {
        value: '',
        error: '',
        enableV2GiftCardForm: false,
    };

    static propTypes = {
        value: PropTypes.string,
        error: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        enableV2GiftCardForm: PropTypes.bool,
    };

    constructor() {
        super();
        this.onChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.value !== nextProps.value || this.props.error !== nextProps.error) {
            return true;
        }
        return false;
    }

    handleChange(value, event) {
        event.preventDefault();
        if (
            giftCardUtility.pinInputCheck(event, this.props.enableV2GiftCardForm) ||
            giftCardUtility.isTargetValueEmpty(event)
        ) {
            this.props.onChange(...giftCardUtility.createPinEventProps(event));
        }
    }

    render() {
        return (
            <InputField
                name={Constants.labelPin}
                id={Constants.labelPin}
                automationId="at-giftcard-pin-text-field"
                errorAutomationId="at-giftcard-pin-form-error"
                value={this.props.value}
                max={this.props.enableV2GiftCardForm ? 8 : 4}
                error={this.props.error}
                onChange={this.onChange}
                onBlur={this.onChange}
                placeholder={Constants.labelPin}
                hasError={!isEmpty(this.props.error)}
                errorMsg={this.props.error}
                dataQmBlock
                datatlPrivate
                infoIconTooltipPlacement="Right"
                infoIconTooltipDirection="Bottomright"
                    // eslint-disable-line
                infoIconTooltipMessage={
                    <span dangerouslySetInnerHTML={{ __html: Constants.toolTipPin }} />
                }
            />
        );
    }
}

export default Pin;
